<template>
  <VModalWidget :dismiss="dismiss">
    <template slot="title">{{ $t('title') }}</template>

    <template slot="footer-actions">
      <AddUserAttribution
        :handleSubmit="add"
        :editable-attribution="editableAttribution"
        :provided-users="boardUsers"
      />
    </template>

    <template slot="content" v-if="loading">
      <v-loading />
    </template>
    <template slot="content" v-else>
      <v-text-field
        v-model="search"
        :placeholder="$t('labels.search')"
        :append-icon="$vuetify.icons.values.search"
        clearable
      />
      <v-data-table
        flat
        :search="search"
        :headers="headers"
        :items="members"
        hide-default-header
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:item="{ item }">
          <UserLine :user="item" :add="add" :destroy="destroy" :editable-attribution="editableAttribution" />
        </template>
      </v-data-table>
    </template>
  </VModalWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { NAMESPACE as ORG_NAMESPACE } from '@argon/iam/organizations/store'
import { NAMESPACE as ATTR_NAMESPACE } from '@argon/iam/attributions/store'
import { VModalWidget, VLoading } from '@argon/app/components'
import { AddUserAttribution, UserLine } from '@argon/iam/components'
import { addAttributionInfo } from '@argon/iam/utils'

export default {
  name: 'EntityUsersWidget',
  components: {
    VModalWidget,
    VLoading,
    AddUserAttribution,
    UserLine
  },
  props: {
    boardRef: {
      type: [String, Number],
      required: true
    },
    entityId: {
      type: [String, Number],
      required: true
    },
    dismiss: { type: Function, required: true },
    editableAttribution: { type: Boolean, default: true }
  },
  data: () => ({
    headers: [{ value: 'icon' }, { value: 'display' }, { value: 'attributionName' }, { value: 'actions' }],
    search: '',
    loading: true
  }),
  computed: {
    ...mapState(NAMESPACE, ['principals', 'boardItem']),
    ...mapState(BOARD_NAMESPACE, { board: 'board', boardPrincipals: 'principals' }),
    ...mapState(ATTR_NAMESPACE, ['attributions']),
    boardUsers() {
      return this.board ? this.board.users : []
    },
    members() {
      let users = this.principals.map((x) => ({ ...x, ...x.user }))
      return addAttributionInfo(users, this.attributions)
    },
    entityURL() {
      return this.boardItem.entity.uris.self
    }
  },
  methods: {
    ...mapActions(BOARD_NAMESPACE, { listBoardPrincipals: 'listPrincipals' }),
    ...mapActions(NAMESPACE, ['listPrincipals', 'addPrincipals', 'deletePrincipals']),
    ...mapActions(ATTR_NAMESPACE, ['listAttributions']),
    add(payload) {
      return this.addPrincipals({
        ...payload,
        baseURL: this.entityURL
      })
    },
    destroy(payload) {
      return this.deletePrincipals({
        principalIds: [payload],
        baseURL: this.entityURL
      })
    }
  },
  mounted() {
    Promise.all([this.listBoardPrincipals(this.boardRef), this.listAttributions(), this.listPrincipals(this.entityURL)])
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Users"
  },
  "fr": {
    "title": "Usagers"
  }
}
</i18n>
